import nkyinkyim from './images/nkyinkyim.svg';
import adinkrahene from './images/adinkrahene.svg';
import gyeNyame from './images/gye-nyame.svg';
import neaOnnim from './images/nea-onnim.svg';
import sankofaBird from './images/sankofa-bird.svg';
import sankofaHeart from './images/sankofa-heart.svg';

const symbols = [
  { name: 'Nkyinkyim', src: nkyinkyim },
  { name: 'Adinkrahene', src: adinkrahene },
  { name: 'Gye Nyame', src: gyeNyame },
  { name: 'Nea Onnim', src: neaOnnim },
  { name: 'Sankofa', src: sankofaBird },
  { name: 'Sankofa', src: sankofaHeart },
];

// Small seeded PRNG so every visitor gets the same order without storing anything
function mulberry32(seed) {
  return () => {
    seed |= 0;
    seed = (seed + 0x6d2b79f5) | 0;
    let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

function shuffledIndices(cycle) {
  const rand = mulberry32(cycle);
  const order = symbols.map((_, i) => i);
  for (let i = order.length - 1; i > 0; i--) {
    const j = Math.floor(rand() * (i + 1));
    [order[i], order[j]] = [order[j], order[i]];
  }
  return order;
}

// Each cycle shows every symbol once; the first pick is swapped if it would repeat the previous cycle's last day
function cycleOrder(cycle) {
  const order = shuffledIndices(cycle);
  const prevLast = shuffledIndices(cycle - 1).at(-1);
  if (order[0] === prevLast) [order[0], order[1]] = [order[1], order[0]];
  return order;
}

// Days since the Unix epoch, counted in New York time to match the header clock
function nyDayNumber(date = new Date()) {
  const [y, m, d] = date
    .toLocaleDateString('en-CA', { timeZone: 'America/New_York' })
    .split('-')
    .map(Number);
  return Math.floor(Date.UTC(y, m - 1, d) / 86400000);
}

export function symbolForDay(day) {
  const n = symbols.length;
  return symbols[cycleOrder(Math.floor(day / n))[day % n]];
}

export function applyDailyLogo() {
  const logo = document.querySelector('.header-logo');
  if (!logo) return;
  const symbol = symbolForDay(nyDayNumber());
  logo.src = symbol.src;
  logo.alt = `Gabe Deko — ${symbol.name}`;
}
